// フリップアニメーション中のカード裏面にあたるコンポーネント

import CardContainer from "./CardContainer";

export default function CharacterCardBack() {
  return (
    <CardContainer />
  );
}
